import { EmailDashboardOverdueComponent } from './email-dashboard-overdue/email-dashboard-overdue.component';
export var emailDashboardOverdueroutes = [
    {
        path: 'email-dashboard-overdue',
        component: EmailDashboardOverdueComponent
    }
];
var EmailDashboardOverdueRoutingModule = (function () {
    function EmailDashboardOverdueRoutingModule() {
    }
    return EmailDashboardOverdueRoutingModule;
}());
export { EmailDashboardOverdueRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard-overdue/email-dashboard-overdue-routing.module.ts.pre-build-optimizer.js